module.exports = new __parcel__URL__("elationemr-blue-logo.f858f2ca.png").toString();